<!-- parttwo -->
<template>
  <div id='parttwo' class="flex-w">
    <app-description :content="content[params.material_type-1]"></app-description>
    <div class="right">
      <app-table :titles="titles" :contents="detail" @detail="openFile" :loading="loading"></app-table>
      <app-upload :uploadList="uploadList" @delete="getData" @upload="getData" :disabled="status===1"></app-upload>
      <button class="app-btn confirm" @click="doConfirm">{{status!==1 ? '提交': '返回'}}</button>
    </div>
  </div>
</template>

<script>
import api from '@/services/server.js'
import { getGradeNumber } from '@/utils/filter'
import { bytesToSize } from '@/utils'
export default {
  data () {
    return {
      status: 1,
      content: [
        ['下载内部动员资料', '查看资料并进行内部动员', '上传PPT和内部动员视频', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈'],
        ['下载双师落地宣传资料包', '根据资料包内容，制作相关宣传物料', '上传校区布置照片', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈'],
        ['下载体验课宣传资料包', '根据运营规划，制作相关物料', '上传宣传照片及体验课细化运营方案', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈'],
        ['下载家长会宣传资料', '根据运营规划，制作相关物料', '上传家长会PPT和讲解视频及家长会流程安排表', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈'],
        ['下载线上集训宣传资料包', '根据运营规划，制作相关物料', '上传活动运营细化方案表（excel）', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈'],
        ['下载短期班宣传资料包', '根据运营规划，制作相关物料', '上传宣传照片及短期班落地实施计划表', '未来魔法校评估决定是否通过，如未通过，需重新提交反馈']],
      titles: [
        { key: 'name', value: '文件名称' },
        { key: 'size', value: '大小' },
        { key: 'updated_at', value: '修改日期' }
      ],
      detail: {},
      uploadList: [],
      params: {
        school_id: this.$route.query.id,
        material_type: this.$route.query.type
      },
      percent: 0,
      loading: false
    }
  },
  components: {},
  mounted () {
    this.getData()
  },
  watch: {
    $route () {
      this.getData()
    }
  },
  methods: {
    getData () {
      if (this.$route.query.grade) {
        let params = {
          material_type: this.$route.query.type,
          grade: this.$route.query.grade
        }
        api.detail(params).then(res => {
          setTimeout(() => {
            this.loading = false
          }, 1000)
          if (res.ok) {
            this.detail = res.data
            this.detail.forEach(v => {
              v.size = bytesToSize(v.size)
            })
          }
        })
      } else {
        // 上面的年级
        api.grade(this.params).then(res => {
          setTimeout(() => {
            this.loading = false
          }, 1000)
          if (res.ok) {
            this.detail = res.data
            this.detail.forEach(v => {
              v.updated_at = v.last_change
              v.name = v.grade
              v.size = bytesToSize(v.size)
            })
          }
        })
      }
      // 下面已经上传过的资料
      api.feedbackList(this.params).then(res => {
        if (res.ok) {
          this.uploadList = res.data.data
          this.status = res.data.status
        }
      })
    },
    openFile (data) {
      this.loading = true
      this.$router.push({ path: '/parttwo', query: { id: this.params.school_id, type: this.params.material_type, grade: getGradeNumber(data.grade) } })
    },
    doConfirm () {
      if (this.uploadList.length > 0) {
        if (this.status !== 1) {
          this.$confirm('提交后不可再上传资料，确认提交?', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            api.feedbackSubmit(this.params).then(res => {
              if (res.ok) {
                this.$message({
                  type: 'success',
                  message: '反馈成功!'
                })
                this.$router.back()
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
            this.getData()
          })
        } else {
          this.$router.back()
        }
      } else {
        this.$message({
          type: 'warning',
          message: '请上传资料'
        })
      }

    }
  }
}
</script>
<style scoped lang='scss'>
#parttwo {
  .confirm {
    margin: 60px auto;
  }
}
</style>
